import useLocale from './useLocale';
import { getLocalizationInfo } from 'project.config';

export const useResolvedLocalizedObject = (localized: object | string) => {
  const { locale: nextLocale } = useLocale();

  const { locale } = getLocalizationInfo(nextLocale);

  return localized[locale as keyof typeof localized] ?? localized ?? '';
};
